/** File format for a table. */
export enum FileDelimiter {
    /** Tab separated table. */
    Comma = ",",
    /** Comma separated table. */
    Semicolon = ";",
    /** Comma separated table. */
    Tab = "\t",
    /** Comma separated table. */
    Unknown = ""
  }